import axios from "axios";

const startCall = async (hs_object_id, phone, extension) => {
  try {
    // Use the correct API URL with port 3001 where the server is running
    const response = await axios.post("/api/start-call", 
      {
        hs_object_id: hs_object_id,
        phone: phone,
        extension: extension
      }, 
      {
        headers: {
          'Cache-Control': 'no-cache, no-store',
          'Pragma': 'no-cache',
          'Expires': '0'
        },
        // Add a timestamp to prevent caching
        params: {
          _t: new Date().getTime()
        }
      }
    );

    console.log("Response:", response);
    return "Call initiated successfully.";
  } catch (error) {
    console.error("Error initiating call:", error);
    
    // Extract the most useful error message
    if (error.response && error.response.data && error.response.data.error) {
      throw new Error(error.response.data.error);
    } else if (error.response && error.response.status) {
      if (error.response.status === 401 || error.response.status === 403) {
        throw new Error("Session expired. Please refresh and try again.");
      } else if (error.response.status === 404) {
        throw new Error("API endpoint not found. Server might be running on a different port.");
      } else {
        throw new Error(`Server error (${error.response.status})`);
      }
    } else if (error.request) {
      throw new Error("No response from server. Please check if the API server is running.");
    } else if (error.message) {
      throw new Error(error.message);
    } else {
      throw new Error("An error occurred during call initiation");
    }
  }
};

export default startCall;
